import React, { useEffect } from 'react'

import { LocationDecorated } from '@shared/types'

import {
  CompanyActions,
  SelectLocationTable,
} from './select-location-table.component'
import { AuditModes } from './select-location.types'
import { useCompaniesEvaluationProfileQuery } from '@shared/hooks/use-companies-evaluation-profiles'
import { useRouter } from '@shared/hooks/use-router'

export function SelectLocationClientPage() {
  const { navigate } = useRouter()
  const { companiesEvaluationProfiles, areCompaniesProfilesLoading } =
    useCompaniesEvaluationProfileQuery()

  const userLocations: LocationDecorated[] = (
    companiesEvaluationProfiles ?? []
  ).map((company) => ({
    ...company,
    action: CompanyActions.PREVIEW,
  }))

  useEffect(() => {
    if (
      companiesEvaluationProfiles &&
      companiesEvaluationProfiles?.length === 1
    ) {
      navigate(`/company-profile/${companiesEvaluationProfiles[0].companyID}`)
    }
  }, [companiesEvaluationProfiles, navigate])

  return (
    <SelectLocationTable
      mode={AuditModes.Other}
      isLoading={areCompaniesProfilesLoading}
      companies={userLocations}
    />
  )
}
